
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/profile-victoria-prodromidis",
      function () {
        return require("private-next-pages/about/profile-victoria-prodromidis.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/profile-victoria-prodromidis"])
      });
    }
  